<template>
  <div class="news-detail-page">
    <div class="news-hero">
      <img src="@/assets/images/新闻背景.png" alt="头图" />
      <div class="hero-text">
        <h1>品牌新闻<span class="en-title"> / NEWS CENTER</span></h1>
      </div>
    </div>

    <div class="news-detail-content">
      <h2>{{ pageTitle }}</h2>
      <p class="meta">2025-08-09 ｜ 👁 1233{{ $t('news.look') }}</p>

      <div v-if="isZh">
        <img src="@/assets/images/sunwaystore/1.jpg" alt="Sunway 开幕活动1" />
        <p>继首次登陆马来西亚并于 Bukit Jalil 开设首店后，CABBEEN 持续拓展其国际版图。2025年8月9日，品牌于吉隆坡 Sunway Velocity 正式启幕第二家门店，以全新空间叙事描绘东方当代男装的审美方向。</p>
        <p>此次开幕活动围绕“能量、节奏与文化流动”展开。街舞、现场DJ、舞狮与即兴走秀交织出现，象征不同文化语境的碰撞与融合。活动现场呈现最新男装系列，并设置限时体验环节与独家礼遇，吸引众多关注当代文化与美学的青年群体到场。</p>
        <p>CABBEEN 在活动中宣布其在马来西亚的持续布局计划——九家新店正逐步推进。品牌将以中国原创设计为核心叙事，结合本地文化语境，构建属于当代亚洲男性的风格语言。</p>
        <img src="@/assets/images/sunwaystore/2.jpg" alt="Sunway 开幕活动1" />
        <p>品牌亦持续深化与本地创意力量的互动——设计师、潮流社群与文化机构皆为其合作对象。CABBEEN 关注城市青年文化的真实能量，并以多维度形式参与公益与社区活动。品牌希望在多元文化交汇的东南亚，建立有温度与思考的文化对话。</p>
        <p>CABBEEN 的视觉语言既温和又坚定。象征力量与精神性的东方符号——书法、龙纹与武学哲思——在其语境下被重新演绎，与全球街头语汇并置，形成一种克制却富有张力的融合表达。它指向一种更广阔的文化自信：不以喧嚣彰显存在，而以深度和独立视角呈现个性。</p>
      </div>
      <div v-else>
        <img src="@/assets/images/sunwaystore/1.jpg" alt="Sunway 开幕活动1" />
        <p>After first entering Malaysia and opening its inaugural store in Bukit Jalil, CABBEEN has continued to expand its international presence. On August 9, 2025, the brand officially launched its second store at Sunway Velocity in Kuala Lumpur, using a new spatial narrative to depict the aesthetic direction of contemporary Eastern menswear.</p>
        <p>The opening event centered around 'Energy, Rhythm, and Cultural Flow.' Street dance, live DJs, lion dancing, and impromptu fashion shows intertwined, symbolizing the collision and fusion of different cultural contexts. The event showcased the latest menswear collection and featured limited-time experiences and exclusive privileges, attracting a large number of young people interested in contemporary culture and aesthetics.</p>
        <p>CABBEEN announced its ongoing expansion plan in Malaysia during the event — nine new stores are gradually being launched. The brand will focus on original Chinese design as its core narrative, combined with the local cultural context, to build a style language for contemporary Asian men.</p>
        <img src="@/assets/images/sunwaystore/2.jpg" alt="Sunway 开幕活动1" />
        <p>The brand also continues to deepen its interaction with local creative forces—designers, trendy communities, and cultural institutions are all its partners. CABBEEN focuses on the authentic energy of urban youth culture and participates in public welfare and community activities in multiple ways. The brand hopes to establish a meaningful and thoughtful cultural dialogue in the multicultural crossroads of Southeast Asia.</p>
        <p>CABBEEN's visual language is both gentle and resolute. Symbolic Eastern elements of power and spirituality—calligraphy, dragon motifs, and martial arts philosophy—are reinterpreted in its context and juxtaposed with global street vernacular, creating a restrained yet dynamic fusion of expression. It points to a broader cultural confidence: not asserting presence through noise, but presenting individuality with depth and an independent perspective.</p>
      </div>

      <div class="back">
        <router-link to="/about" class="back-button">
          <span class="arrow">←</span> 返回 / return
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  name: 'Newsssunway',
  setup() {
    const { locale } = useI18n()
    const pageTitle = computed(() => (
      locale.value === 'zh'
        ? 'CABBEEN 于吉隆坡 Sunway Velocity 呈献马来西亚第二家门店'
        : 'CABBEEN presents its second store in Malaysia at Sunway Velocity, Kuala Lumpur'
    ))
    const isZh = computed(() => locale.value === 'zh')
    return { pageTitle, isZh }
  },
}
</script>

<style scoped>
.news-detail-page {
  background: black;
  color: white;
  padding-bottom: 60px;
}

/* hero部分样式 */
.news-hero {
  position: relative;
  height: 230px;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
}
.news-hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
}
.hero-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  padding: 0 20px;
  white-space: nowrap;
}
.hero-text h1 {
  font-size: 20px;
  font-weight: bold;
  margin: 0;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  display: inline-block;
}
.en-title {
  display: inline;
  font-size: 20px;
  font-weight: normal;
  margin-left: 8px;
  letter-spacing: 0.5px;
  color: #ffb100;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.news-detail-content {
  max-width: 900px;
  margin: 40px auto;
  padding: 0 20px;
}
.news-detail-content h2 {
  color: #ffb100;
  font-size: 26px;
  margin-bottom: 40px;
  text-align: center;
  padding: 0 20px;
}
.news-detail-content .meta {
  font-size: 13px;
  color: #aaa;
  margin-bottom: 20px;
  text-align: center;
}
.news-detail-content p {
  line-height: 1.8;
  margin-bottom: 15px;
  text-align: justify;
  text-indent: 2em;
  font-size: 16px;
}
.news-detail-content img {
  width: 100%;
  margin: 20px 0;
  border-radius: 8px;
}
.back {
  margin-top: 40px;
  text-align: center;
}

.back-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 24px;
  background-color: #000;
  color: #ffb100;
  border: 1px solid #ffb100;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  min-width: 120px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.back-button:hover {
  background-color: #ffb100;
  color: #000;
  border-color: #000;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(255, 179, 0, 0.2);
}

.back-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(255, 179, 0, 0.2);
}

.arrow {
  margin-right: 8px;
  font-size: 18px;
}

@media (max-width: 768px) {
  .news-hero {
    height: 180px;
  }
  .hero-text h1 {
    font-size: 18px;
  }
  .news-detail-content {
    max-width: 100%;
    margin: 20px 10px;
    padding: 0 10px;
  }
  .news-detail-content h2 {
    font-size: 22px;
  }
  .news-detail-content .meta {
    font-size: 12px;
  }
  .news-detail-content p {
    font-size: 14px;
  }
  .news-detail-content img {
    margin: 10px 0;
  }
  .back-button {
    padding: 8px 18px;
    font-size: 14px;
  }
}
</style>


